import Badge from './Badge';
import Tooltip, { TooltipProps } from './Tooltip';

export function BetaBadge({ placement = 'top-end' }: { placement?: TooltipProps['placement'] }) {
    return (
        <Tooltip
            placement={placement}
            tooltip={
                <p className="tw-my-2 tw-max-w-[220px] tw-text-xs tw-text-accents-7">
                    Diese Funktion befindet sich in der Beta-Phase. Sie kann sich noch ändern oder eingeschränkt
                    verfügbar sein. Wir freuen uns über dein Feedback.
                </p>
            }
            className="tw-inline-flex"
            withArrow
        >
            <Badge color="beta" size="xs" className="tw-pointer-events-none tw-select-none tw-uppercase">
                Beta
            </Badge>
        </Tooltip>
    );
}
